import { render, staticRenderFns } from "./crunchie1.vue?vue&type=template&id=36204e97&scoped=true&"
import script from "./crunchie1.vue?vue&type=script&lang=js&"
export * from "./crunchie1.vue?vue&type=script&lang=js&"
import style0 from "./crunchie1.vue?vue&type=style&index=0&id=36204e97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36204e97",
  null
  
)

export default component.exports